import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'app-contacto',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.scss']
})
export class ContactoComponent {
  // Paleta Alphatec
  brandPrimary = '#1B07A7';
  brandAccent  = '#FF5D3C';

  form = this.fb.group({
    name: ['', [Validators.required, Validators.minLength(2)]],
    email: ['', [Validators.required, Validators.email]],
    subject: ['', [Validators.required, Validators.minLength(3)]],
    message: [''],
  });

  isSubmitting = false;

  constructor(private fb: FormBuilder) {}

  controlInvalid(ctrl: string) {
    const c = this.form.get(ctrl);
    return !!c && c.touched && c.invalid;
  }

  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.isSubmitting = true;

    // TODO: Reemplaza por tu HttpClient.post(...) a tu API
    setTimeout(() => {
      this.isSubmitting = false;
      alert('¡Mensaje enviado!');
      this.form.reset();
    }, 800);
  }
}
